var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "person_play"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1650_13173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.511719,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1650_13173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_play_2",
    d: "M7.6914 16.481L3.77344 12.5631L7.6914 8.67077L11.5837 12.5631L7.6914 16.481ZM13.076 28.5118V22.3836C11.7717 22.2725 10.4743 22.1285 9.1837 21.9515C7.8931 21.7746 6.60935 21.5255 5.33244 21.2041L5.64014 19.8708C7.35296 20.2964 9.06614 20.5994 10.7797 20.7797C12.4932 20.9601 14.2321 21.0503 15.9963 21.0503C17.7606 21.0503 19.5004 20.9601 21.2158 20.7797C22.9312 20.5994 24.6452 20.2964 26.3581 19.8708L26.6658 21.2041C25.3889 21.5255 24.1051 21.7746 22.8145 21.9515C21.5239 22.1285 20.2265 22.2725 18.9222 22.3836V28.5118H13.076ZM7.6914 14.6195L9.72217 12.5631L7.6914 10.5323L5.635 12.5631L7.6914 14.6195ZM15.9991 10.358C15.1444 10.358 14.4179 10.0588 13.8196 9.4605C13.2213 8.86221 12.9222 8.13573 12.9222 7.28104C12.9222 6.42633 13.2213 5.69983 13.8196 5.10154C14.4179 4.50325 15.1444 4.2041 15.9991 4.2041C16.8538 4.2041 17.5803 4.50325 18.1786 5.10154C18.7769 5.69983 19.076 6.42633 19.076 7.28104C19.076 8.13573 18.7769 8.86221 18.1786 9.4605C17.5803 10.0588 16.8538 10.358 15.9991 10.358ZM15.9991 18.8964C15.3786 18.8964 14.8474 18.6755 14.4055 18.2336C13.9636 17.7917 13.7427 17.2605 13.7427 16.64C13.7427 16.0195 13.9636 15.4883 14.4055 15.0464C14.8474 14.6045 15.3786 14.3836 15.9991 14.3836C16.6196 14.3836 17.1508 14.6045 17.5927 15.0464C18.0346 15.4883 18.2555 16.0195 18.2555 16.64C18.2555 17.2605 18.0346 17.7917 17.5927 18.2336C17.1508 18.6755 16.6196 18.8964 15.9991 18.8964ZM15.9991 9.0246C16.4794 9.0246 16.8901 8.85409 17.2311 8.51307C17.5722 8.17205 17.7427 7.76137 17.7427 7.28104C17.7427 6.80068 17.5722 6.38999 17.2311 6.04897C16.8901 5.70795 16.4794 5.53743 15.9991 5.53743C15.5188 5.53743 15.1081 5.70795 14.7671 6.04897C14.426 6.38999 14.2555 6.80068 14.2555 7.28104C14.2555 7.76137 14.426 8.17205 14.7671 8.51307C15.1081 8.85409 15.5188 9.0246 15.9991 9.0246ZM22.6555 16.3067L20.9017 13.2297L22.6555 10.1528H26.0863L27.8401 13.2297L26.0863 16.3067H22.6555ZM23.4025 14.9733H25.3478L26.3119 13.2297L25.3393 11.4862H23.394L22.4299 13.2297L23.4025 14.9733Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPlay);
export default __webpack_public_path__ + "static/media/person-play.5c00639c5573e678d56129c49dc01e3e.svg";
export { ForwardRef as ReactComponent };